/**
 *
 * SettingsPage14852
 *
 */

import React from 'react';
import SettingsPage from 'pages/Settings/SettingsPage';
import {UsersForm14852} from "./UsersView";

function SettingsPage14852(props) {
    return (
        <SettingsPage
            administratorBCForm={<UsersForm14852/>}
            {...props}
        />
    );
}

export default SettingsPage14852;